import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedGridLayoutNode } from 'ContentEditorUI/redux/selectors/selectionSelectors';
// @ts-ignore not yet typed
import { addActiveClass, removeActiveClass } from 'InpageEditorUI/lib/dom';
import usePrevious from 'react-utils/hooks/usePrevious';
import { getGridNodeElement } from 'layout-dnd-utils/grids/render/domSelectors';
export default function GridLayoutSelectedNodeContainer() {
  const selectedGridLayoutNode = useSelector(getSelectedGridLayoutNode);
  const prevSelectedGridLayoutNode = usePrevious(selectedGridLayoutNode);
  useEffect(() => {
    if (prevSelectedGridLayoutNode && prevSelectedGridLayoutNode !== selectedGridLayoutNode) {
      const elem = getGridNodeElement(prevSelectedGridLayoutNode);
      removeActiveClass(elem);
    }

    // We exclude Modules in the last clause of the if because highlighting it is
    // handled by WidgetEditor.js
    if (selectedGridLayoutNode && selectedGridLayoutNode !== prevSelectedGridLayoutNode && !selectedGridLayoutNode.isModule()) {
      const elem = getGridNodeElement(selectedGridLayoutNode);
      addActiveClass(elem);
    }
  }, [selectedGridLayoutNode, prevSelectedGridLayoutNode]);
  return null;
}